import React from "react";

export const LocalizationContext = React.createContext({});

export const LocalizationProvider = LocalizationContext.Provider;
